import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useNeuroMessages } from './MessageContext';
import NeuroMessage from './NeuroMessage';
import notification, { NotificationMessage } from './ToastNotifications';
import { formatNumberQuestionValues } from '../utils';

/**
 * Provides generic way to render question validation error messages
 */
const ValidationMessages = ({ validationErrors, render }) => {
  const messageContext = useNeuroMessages();

  const defaultRender = (title, errors = [], key) => {
    return (
      <div className="validation-error-message" key={key}>
        <h1>{title}</h1>
        {errors.map((e, i) => (
          <span key={i}>{e}</span>
        ))}
      </div>
    );
  };

  return validationErrors.map((error) => {
    const title =
      error.fieldType === 'question' ? (
        <NeuroMessage
          id={
            messageContext.hasMessage(`details.${error.key}`)
              ? `details.${error.key}`
              : error.key
          }
        />
      ) : null;
    const errors = renderQuestionErrors(error);
    return render
      ? render({ title, errors, key: error.key })
      : defaultRender(title, errors, error.key);
  });
};
ValidationMessages.propTypes = {
  validationErrors: PropTypes.array.isRequired,
  render: PropTypes.func,
};

const renderQuestionErrors = (error) => {
  const messageContext = useNeuroMessages();
  
  return Object.keys(error.errors).map((type, index) => {
    let values = error.errors[type];
    const formatType = error.questionType || error?.attributes?.format;
    const validationType =
      type === 'between' && values.length > 1 && values[0] === values[1]
        ? 'equal'
        : type;
    values = formatType
      ? formatNumberQuestionValues(formatType, values)
      : values;
    return (
      <NeuroMessage
        shouldHideIfNotFound={true}
        key={`error-${index}`}
        id={
          messageContext.hasMessage(`${error.key}.error.question.${validationType}`)
            ? `${error.key}.error.question.${validationType}`
            : `error.question.${validationType}`
        }
        values={{ ...values }}
      />
    );
  });
};

const renderQuestionErrorsNotification = (validationErrors) => {
  const message = (
    <NotificationMessage
      icon={<i className="ion-alert-circled" />}
      title={<FormattedMessage id="error.title" />}
      message={<ValidationMessages validationErrors={validationErrors || []} />}
    />
  );
  notification({
    id: 'validationErrors',
    message,
    type: 'error',
    autoClose: 10000,
  });
};

export {
  ValidationMessages as default,
  renderQuestionErrors,
  renderQuestionErrorsNotification,
};
